import { createElementBlock as l, openBlock as a, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(t, e) {
  return a(), l("svg", o, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.882 2a1 1 0 1 0-2 0v1a3 3 0 0 0-3 3v2.456l-1.63 1.055a3 3 0 0 0-1.37 2.518V15a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V6a3 3 0 0 0-3-3zm1 8.9V6a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v6a1 1 0 1 1-2 0v-1.162l-.544.352a1 1 0 0 0-.456.84V15h7zM4.034 12.964a1 1 0 0 0-.534-1.928l-.3.083a3 3 0 0 0-1.74 4.485l3.634 5.793a3 3 0 0 0 3.046 1.364l11.626-1.984A3 3 0 0 0 22.06 18.9l1.099-2.844a3 3 0 0 0-1.457-3.765l-.373-.186a1 1 0 0 0-.895 1.788l.374.187a1 1 0 0 1 .485 1.255l-1.098 2.844a1 1 0 0 1-.765.625L7.804 20.79a1 1 0 0 1-1.016-.454l-3.633-5.793a1 1 0 0 1 .58-1.495z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
//# sourceMappingURL=ic_businessarea-DqVaGJcr.js.map
